import { createReducer, on } from '@ngrx/store';
import { loadListFailure, loadListSuccess, toggleLoadingStatus } from './store.actions';
import { initialUIState } from './store.state';

export const _uiReducer = createReducer(
  initialUIState,
  on(toggleLoadingStatus, (state, action) => ({
    ...state,
    isLoading: action.status,
  })),
  on(loadListFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(loadListSuccess, (state, action) => ({
    ...state,
    list: action.payload,
    isLoading: false,
  })),
);

export function uiReducer(state: any, action: any) {
  return _uiReducer(state, action);
}
